import ComponentTree from './ComponentTree';
import './Tree.scss';

export default ComponentTree;
